<template>
  <div ref="root">
    <slot />
  </div>
</template>

<script setup>
import gsap from 'gsap'
import Cookies from 'js-cookie'
import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue'
import useEmitter from '@composables/useEmitter'

const root = ref(null)
const emitter = useEmitter()
let ctx
let timeline
let hasPlayed = false

function playIntro() {
  if (!timeline || hasPlayed) return

  hasPlayed = true
  timeline.play(0)
}

onMounted(async () => {
  await nextTick()

  if (!root.value) return

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  if (prefersReducedMotion) {
    root.value.removeAttribute('data-blog-intro-pending')
    return
  }

  ctx = gsap.context(() => {
    const beads = gsap.utils.toArray('.beads img', root.value)

    gsap.set(root.value, {
      autoAlpha: 0,
      scale: 0.08,
      rotation: -18,
      yPercent: 7,
      transformOrigin: '50% 58%',
      force3D: true,
      willChange: 'transform, opacity',
    })

    gsap.set(beads, {
      autoAlpha: 0,
      scale: 0.42,
      yPercent: -24,
      rotation: (index) => [-24, 18, -16, 21][index % 4],
      transformOrigin: '50% 50%',
      force3D: true,
      willChange: 'transform, opacity',
    })

    root.value.removeAttribute('data-blog-intro-pending')

    timeline = gsap.timeline({
      paused: true,
      onComplete: () => {
        gsap.set([root.value, ...beads], {
          clearProps: 'transform,opacity,visibility,willChange',
        })
      },
    })
      .to(root.value, {
        autoAlpha: 1,
        scale: 1,
        rotation: 0,
        yPercent: 0,
        duration: 0.9,
        ease: 'back.out(1.25)',
      })
      .to(beads, {
        autoAlpha: 1,
        scale: 1,
        yPercent: 0,
        rotation: 0,
        duration: 0.36,
        ease: 'back.out(2.8)',
        stagger: 0.07,
      }, '+=0.05')
  }, root.value)

  if (Cookies.get('ofage')) {
    playIntro()
    return
  }

  emitter.on('ofage', playIntro)
})

onBeforeUnmount(() => {
  emitter.off('ofage', playIntro)
  ctx?.revert()
})
</script>
